<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
      :loading="false"
  >
    <template #layoutContent>
      <Loader :isLoading="isLoading">
        <div id="" class="">
          <div class="card mb-5">
            <div class="card-body pt-9 pb-0">
              <div class="d-flex flex-column flex-sm-row flex-wrap flex-sm-nowrap">
                <div class="flex-grow-1">
                  <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
                    <div class="d-flex flex-column">
                      <div class="d-flex align-items-center mb-2 flex-wrap">
                        <a href="#" class="text-primary fs-2 fw-bold me-1">{{ pipeline?.name }}</a>
                        <a href="#">
                          <i class="ki-duotone ki-verify fs-1 text-primary">
                            <span class="path1"></span><span class="path2"></span>
                          </i>
                        </a>
                      </div>
                      <div class="d-flex flex-column flex-sm-row flex-wrap fw-semibold fs-6 mb-4 pe-2">
                        <a href="#" class="d-flex align-items-center text-gray-500 me-5 mb-2">
                          <i class="bi bi-calendar-date-fill text-gray-500 me-3"></i>
                          <span class="text-gray-500 me-3">{{ $t("crm.label.startDate") }}</span>
                          <span class="text-gray-500 me-3">|</span>
                          <span class="text-dark">{{ pipeline?.creation_date ? formatDate(pipeline?.creation_date) : $t('pipelines.no_enter') }}</span>
                        </a>
                        <a href="#" class="d-flex align-items-center text-gray-500 me-5 mb-2">
                          <i class="bi bi-calendar-date-fill text-gray-500 me-3"></i>
                          <span class="text-gray-500 me-3">{{$t("pipelines.label.opportunity_closing_date") }}</span>
                          <span class="text-gray-500 me-3">|</span>
                          <span class="text-dark">{{ pipeline?.closing_date ? formatDate(pipeline?.closing_date) : $t('pipelines.no_enter')}}</span>
                        </a>
                        <span class="badge badge-light-success mb-3 fs-3 text-wrap" v-if="pipeline?.status == 'WON'">
                                <i class="fas fa-trophy fs-1 me-2 text-success"></i>{{$t('crm.label.won')}}
                            </span>
                        <span class="badge badge-light-danger mb-3 fs-3 text-wrap" v-if="pipeline?.status == 'LOST'">
                                <i class="fas fa-heartbeat fs-1 me-2 text-danger"></i>{{$t('crm.label.lose')}}
                            </span>
                      </div>
                    </div>
                    <div class="d-flex my-4" v-if="showAction" >
                      <ButtonDropdown
                          :btn-title="$t('label.action')"
                          :search="false"
                          :options="listActions"
                          value-field="value"
                          name-field="name"
                          :show-icon="false"
                          v-model="action"
                          btn-class="mb-2 btn-sm"
                      />
                    </div>
                  </div>
                  <div class="d-flex flex-wrap align-items-start flex-stack">
                    <div class="d-flex flex-column flex-grow-1 pe-8">
                      <Stepper :selected="pipeline?.opportunityState"/>
                    </div>
                    <div class="d-flex mt-2 mt-sm-0" style="margin-top: -10px">
                      <OutlineButton btn-class="me-2 btn-sm" type="primary" :border="true" btn-text="crm.label.reopen" v-if="(pipeline && (pipeline?.status == 'WON' || pipeline?.status == 'LOST')) && ($can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES))" :is-disabled="isLoadingNew" @click="changeNewPipeline"/>
                      <OutlineButton btn-class="me-2 btn-sm" icon-class="fas fa-trophy" type="success" btn-text="crm.label.win" @click="openWonModal" v-if="(pipeline && pipeline.status != 'WON' && pipeline.status != 'LOST' && pipeline.status != 'ARCHIVED') && ($can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES))"/>
                      <OutlineButton btn-class="btn-sm" icon-class="fas fa-heartbeat" type="danger" btn-text="crm.label.loose" @click="openLostModal" v-if="(pipeline && pipeline?.status != 'WON' && pipeline?.status != 'LOST') && pipeline.status != 'ARCHIVED' && ($can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES))"/>
                      <OutlineButton btn-class="btn-sm" type="danger" btn-text="pipelines.label.reasons" @click="openMotifModal" v-if="pipeline?.status == 'LOST'"/>
                    </div>
                  </div>
                </div>
              </div>
              <br>
              <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                <li class="nav-item mt-2" @click="clickOnTab('kt_tab_list')" v-show="$can(abilities.VIEW_OPPORTUNITIES) || $can(abilities.VIEW_ALL_OPPORTUNITIES)">
                  <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : route.query.tab === 'kt_tab_list' }"  data-bs-toggle="tab" href="#kt_tab_list">
                    {{ $t("crm.label.informations") }}
                  </a>
                </li>
                <li class="nav-item mt-2" @click="clickOnTab('kt_tab_activity')"  v-show="$can(abilities.VIEW_ACTIVITY)">
                  <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : route.query.tab === 'kt_tab_activity' }" data-bs-toggle="tab" href="#kt_tab_activity">
                    {{ $t("crm.pipeline.activity.liste") }}
                  </a>
                </li>
                <li class="nav-item mt-2" @click="clickOnTab('kt_tab_estimate')" v-show="$can(abilities.VIEW_ESTIMATE_OPPORTUNITIES)">
                  <a class="nav-link text-active-primary ms-0 me-10 py-5" :class="{'active' : route.query.tab === 'kt_tab_estimate' }"  data-bs-toggle="tab" href="#kt_tab_estimate">
                    {{ $t("devis.devis") }} <span class="ms-2 text-success mb-4">{{ validateEstimatesCount }}</span>
                  </a>
                </li>
                <li class="nav-item mt-2" @click="clickOnTab('kt_tab_invoice')" v-show="$can(abilities.VIEW_INVOICE_OPPORTUNITIES)">
                  <a class="nav-link text-active-primary ms-0 me-10 py-5"  :class="{'active' : route.query.tab === 'kt_tab_invoice' }" data-bs-toggle="tab" href="#kt_tab_invoice">
                    {{ $t("invoices.invoice") }}<span class="ms-2 text-success mb-4">{{validateInvoicesCount}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'kt_tab_list' }" id="kt_tab_list" v-show="$can(abilities.VIEW_OPPORTUNITIES) || $can(abilities.VIEW_ALL_OPPORTUNITIES)" role="tabpanel">
              <Information @data-updated="updateData" :pipeline="pipeline"/>
            </div>
            <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'kt_tab_activity' }" id="kt_tab_activity" v-show="$can(abilities.VIEW_ACTIVITY)" role="tabpanel">
              <Activity :pipeline="pipeline"/>
            </div>
            <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'kt_tab_estimate' }" id="kt_tab_estimate" v-show="$can(abilities.VIEW_ESTIMATE_OPPORTUNITIES)" role="tabpanel">
              <Estimate :pipeline="pipeline" />
            </div>
            <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'kt_tab_invoice' }" id="kt_tab_invoice" role="tabpanel" v-show="$can(abilities.VIEW_INVOICE_OPPORTUNITIES)">
              <Invoice :pipeline="pipeline" />
            </div>
          </div>
        </div>
        <WonOpportunity :date="pipeline.closing_date"  id="wonModal" @load="loadPipelineData"/>
        <LooseOpportunity :date="pipeline.closing_date" id="lostModal" @load="loadPipelineData"/>
        <looseMotifOpportunity id="motifModal" :reason="pipeline?.lost_opportunity"/>
      </Loader>
    </template>

  </SubLayout>
</template>
<script setup>
import {computed, onUpdated, onMounted, ref, watch, nextTick} from "vue";
import {useStore} from "vuex";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import { useRouter, useRoute } from 'vue-router';
import OutlineButton from "@/components/OutlineButton";
import Stepper from "@/components/Stepper";
import Activity from "@/Modules/CRM/views/Pipeline/components/Activity";
import Information from "@/Modules/CRM/views/Pipeline/components/Information.vue";
import i18n from "@/plugins/i18n";
import WonOpportunity from "@/Modules/CRM/components/Modals/Pipeline/WonOpportunity";
import LooseOpportunity from "@/Modules/CRM/components/Modals/Pipeline/LooseOpportunity";
import Loader from "@/components/Loader";
import ButtonDropdown from "@/components/ButtonDropdown.vue";
import Estimate from "@/Modules/CRM/views/Pipeline/components/Estimate.vue";
import Invoice from "@/Modules/CRM/views/Pipeline/components/Invoice.vue";
import looseMotifOpportunity from "@/Modules/CRM/components/Modals/Pipeline/looseMotifOpportunity";
import abilities from "@/composables/abilities";
import {useHasAbility} from "@/composables/hasAbility"; 

const store = useStore()
const router = useRouter()
const route = useRoute()

const title = ref( "crm.pipeline.title")
const isLoadingNew = ref(false)
const isLoading = ref(true)
const pipeline = ref("")
const showStat = ref(true)
const { can } = useHasAbility()
const breadcrumbs = ref([
  {
    name: 'crm.pipeline.opportunityList',
    route: 'pipelines'
  },
  {
    name: 'crm.pipeline.detail',
    route: 'pipelines-view',
    params: route.params.id
  }
])

const action = ref('')

const listActions = computed(() => {
  const actions = []

  if(can(abilities.CREATE_ESTIMATE)){
    actions.push({
      name: i18n.global.t("pipelines.generate_estimate"),
      value: "estimate"
    })
  }
  if(can(abilities.CREATE_INVOICE)){
    actions.push({
      name: i18n.global.t("pipelines.generate_invoice"),
      value: "invoice"
    })
  }
  if(can(abilities.ARCHIVE_OPPORTUNITIES) && pipeline.value.status !== 'ARCHIVED'){
    actions.push({
      name: i18n.global.t("pipelines.archive"),
      value: "archive"
    })
  }

  return actions
})

const validateEstimatesCount = computed(() => {
  let estimates = pipeline.value?.estimates?.filter(estimate => estimate.status == "APPROVED")
  return estimates.length
})

const validateInvoicesCount = computed(() => {
  let invoices = pipeline.value?.invoices?.filter(invoice => invoice.invoice_status == "VALIDATED")
  return invoices.length
})

const showAction = computed(() => {
  return pipeline.value.status === 'NEW'
})

watch(() => action.value, () => {
  if(action.value == 'archive'){
    archivedPipeline()
  }
  if(action.value == 'invoice'){
    generateInvoice()
  }
  if(action.value == 'estimate'){
    generateEstimate()
  }
})

function loadData() {
  Promise.all([
    store.dispatch('activity/loadActivityTypes')
  ])
}

function openMotifModal(){
  $('#motifModal').modal('toggle')
}

function generateEstimate(){
  let products = pipeline.value.productSaleElements.map((item) => {
    return {
      id: item.id,
      quantity: 1,
      price: item.selling_price,
      taxes: item.taxes.map(tax => tax.id)
    }
  })
  const data = {
    opportunity_id: pipeline.value.id,
    contact_id: pipeline.value.contact_id,
    products: JSON.stringify(products)
  }

  router.push({
    name: 'estimates-create',
    query: data
  })
}

function generateInvoice(){
  let products = pipeline.value.productSaleElements.map((item) => {
    return {
      id: item.id,
      quantity: 1,
      price: item.selling_price,
      taxes: item.taxes.map(tax => tax.id)
    }
  })
  const data = {
    opportunity_id: pipeline.value.id,
    contact_id: pipeline.value.contact_id,
    products: JSON.stringify(products)
  }

  router.push({
    name: 'invoices-create',
    query: data
  })
}

onMounted( () => {
  loadData()
  if(!route.query.tab){
    clickOnTab('kt_tab_list')
  }
})

function openWonModal(){
  $('#wonModal').modal('toggle')
}

function openLostModal(){
  $('#lostModal').modal('toggle')
}

function loadPipelineData(){
  store.dispatch('pipelines/getPipeline', route.params.id).then((res) => {
    pipeline.value = res.data?.data
    if(Object.values(pipeline.value).length > 0){
      isLoading.value = false
    }
  })
}

function formatDate(date){
  let _date = date?.split("-").reverse().join("-")
  return new Date(_date)?.toLocaleDateString('fr-FR', { month: 'long', day: 'numeric', year: "numeric" })
}

function changeNewPipeline(){
  isLoadingNew.value = true
  store.dispatch('pipelines/changeStatusPipeline', {opportunity_id: route.params.id, status: 'NEW'})
      .then(res => {
        loadPipelineData()
        isLoadingNew.value = false
        window.toastr['success'](i18n.global.t("notification.pipeline_reopen"))
      })
      .catch((err) => {
        isLoadingNew.value = false

      })
}

function clickOnTab(tabId){
  router.replace({ query: { ...route.query, tab: tabId } });
}

function archivedPipeline(){
  isLoadingNew.value = true
  store.dispatch('pipelines/archivePipeline', {opportunity_id: route.params.id})
      .then(res => {
        loadPipelineData()
        window.toastr['success'](i18n.global.t("notification.pipeline_archived"))
      })
      .catch((err) => {
      })
}

function updateData(newData){
  pipeline.value = newData
}


onMounted(() => {
  loadPipelineData()
  store.dispatch('reasons/loadReasons')
  store.dispatch('pipelines/loadPipelineStates')
})
</script>

<style scoped>
.shadow {
  box-shadow: 0 0.2rem 0.5rem 0.2rem rgba(0, 0, 0, .075) !important;
}
</style>
